import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/Home.vue";
import LoginView from "../views/Login.vue";
import Cookies from "js-cookie";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { requiresAuth: false },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // const isAuthenticated = localStorage.getItem('isAuthenticated')
  const cookie = Cookies.get("satoken");
  const isAuthenticated = cookie !== undefined && cookie !== null;
  console.log(isAuthenticated);

  if (  !isAuthenticated && to.path !== "/login") {
    next("/login");
  } else if (to.path === "/login" && isAuthenticated) {
    next("/");
  } else {
    next();
  }
});

export default router;
